import * as Sentry from "@sentry/gatsby";

Sentry.init({
  dsn: "https://0dc60039b18b47c0de20f9c088d83f5a@o4509870794932224.ingest.de.sentry.io/4509871650832464",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  environment: process.env.USER_BRANCH || "development",
});